import { z } from 'zod';

/**
 * Columns the Past Reports list can be ordered by. `market` and `owner` order by
 * the related market name / owner display name rather than the foreign key, so the
 * order matches the labels the table renders.
 */
export const PREFLIGHT_REPORT_SORT_FIELDS = [
    'name',
    'brandName',
    'createdAt',
    'assetCount',
    'market',
    'overallScore',
    'owner',
] as const;

export const PreflightReportSortFieldSchema = z.enum(PREFLIGHT_REPORT_SORT_FIELDS);
export type PreflightReportSortField = z.infer<typeof PreflightReportSortFieldSchema>;

export const PreflightReportSortOrderSchema = z.enum(['asc', 'desc']);
export type PreflightReportSortOrder = z.infer<typeof PreflightReportSortOrderSchema>;

export const DEFAULT_PREFLIGHT_REPORT_SORT_FIELD: PreflightReportSortField = 'createdAt';
export const DEFAULT_PREFLIGHT_REPORT_SORT_ORDER: PreflightReportSortOrder = 'desc';

/**
 * Direction a column starts in when the user first sorts by it: newest, biggest
 * and highest-scoring first for dates and numbers, A→Z for text.
 */
const DESCENDING_FIRST_FIELDS = new Set<PreflightReportSortField>([
    'createdAt',
    'assetCount',
    'overallScore',
]);

export function defaultPreflightReportSortOrder(
    field: PreflightReportSortField,
): PreflightReportSortOrder {
    return DESCENDING_FIRST_FIELDS.has(field) ? 'desc' : 'asc';
}
